import classnames from 'classnames';
import { Form, Formik } from 'formik';
import { pick } from 'lodash';
import React from 'react';
import { Translate, withLocalize } from 'react-localize-redux';
import * as Yup from '../common/Yup';
import ModalInner from '../layoutItems/modalInner';
import BbInput from '../styling/bbInput';

class RenameProfilePopup extends React.Component {

    render() {
        return (
            <ModalInner title={this.props.translate('Charts.ProfileRename')} close={this.props.close}>
                <Formik
                    ref={(el) => this.formRef = el}
                    enableReinitialize={true}
                    validationSchema={this.createValidationSchema()}
                    validateOnChange={false}
                    validateOnBlur={false}
                    initialValues={{
                        name: this.props.oldName,
                    }}
                    onSubmit={(values, { setSubmitting }) => {
                        setSubmitting(false);
                        this.props.saveName(values.name);
                    }}
                >
                    {() => (
                        <Form autoComplete="off">
                            <BbInput name="name" type="text" label={this.props.translate('Charts.ProfileNewName')} placeholder={{ type: 'column' }} />
                            <div className="modal-inner-buttons" style={{ marginTop: '3em' }}>
                                <button className={classnames('bb-button gradient-1-gray', { 'is-square': localStorage.locales_button_style === 'square' })} onClick={this.props.close}>
                                    <Translate id='Common.Button.Cancel' />
                                </button>
                                <button type="submit" className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}><Translate id="Charts.Rename" /></button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </ModalInner>
        )
    }

    createValidationSchema = () => {
        const wrongInputMsg = this.props.translate("Search.Common.Validation.WrongInput");
        const schema = {
            'name': Yup.string().trim().required(wrongInputMsg)
        };
        return Yup.object().shape(pick(schema, ['name']));
    }
}

export default withLocalize(RenameProfilePopup);
